module.exports = __webpack_public_path__ + "assets/img/school.5b9b85fd.jpeg";